module.exports = __webpack_public_path__ + "img/apple.dd0ea11a.png";